import BaseModel from "../../BaseModal"
import styled, { css } from 'styled-components';
import { BaseButton } from '../../styles/ButtonStyles';
import { InputText } from '../../styles/TextStyles';
import React from 'react';
import './Modal.css';

import {
    FlexWrapperCenter,

} from '../../styles/WrapperStyles';

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
        props.small &&
        css`
      font-size: 16px;
    `}
`;

const RefIdInput = styled(InputText)`
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
`;


const TransferSubModal = (props) => {
    const [transferRefId, setTransferRefId] = React.useState('');
    let urlType;
    if (props.modalText === 'Transfer to REF ID') {
        urlType = 'transferSubscription';
    } else if (props.modalText === 'Enable Exclusivity') {
        urlType = 'enableExclusivity';
    } else {
        urlType = 'sendPaymentLink';
    }
    return (
        <BaseModel closeModal={props.closeModal}>
            <FlexWrapperCenter className="modalTransfer">
                <TextView>{props.modalText}</TextView>
                <RefIdInput onChange={e => { setTransferRefId(e.target.value) }}></RefIdInput>
                <BaseButton
                    onClick={() => {
                        if (transferRefId !== '') {
                            props.handleButtonEvents(urlType, transferRefId);
                        }
                    }}
                >
                    Save
                </BaseButton>
            </FlexWrapperCenter>
        </BaseModel>
    )
}

export default TransferSubModal;